import type {SyncIntegration} from '@cohort/merchants/apps';
import MaxxingSyncConfigComponent from '@cohort/merchants/apps/maxxing/sync/SyncConfigComponent';
import type {MaxxingSyncStruct} from '@cohort/shared/apps/maxxing/sync';
import {MaxxingSyncSpec} from '@cohort/shared/apps/maxxing/sync';

export const MaxxingSyncIntegration: SyncIntegration<MaxxingSyncStruct> = {
  spec: MaxxingSyncSpec,
  syncConfigComponent: MaxxingSyncConfigComponent,
};
